import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListContainer from 'Components/UI/Containers/ListContainer/ListContainer';
import { Icon } from 'Components/UI';
import { IAccountInfo } from 'Data/interfaces/Obra/IAccountInfo';
import { getIconApi, ApisEnumLabel } from 'Data/enums/Apis';
import { Container } from './styles';

const Apis = [2, 3, 5];

interface IArmazenamentoTab {
  isSubmited?: boolean;
  accountsInfo?: IAccountInfo[];
  accountIdSelected?: number;
  onSubmit: (values?: any, errors?: string[]) => void;
}

const ArmazenamentoTab: FC<IArmazenamentoTab> = ({
  isSubmited,
  accountsInfo,
  accountIdSelected,
  onSubmit,
}) => {
  const { t } = useTranslation('obras');
  const [selectedAccountRow, setSelectedAccountRow] = useState<number | undefined>();
  const [selectedServiceRow, setSelectedServiceRow] = useState<number>();
  const [keySelected, setKeySelected] = useState<number | undefined>(
    accountsInfo?.findIndex(x => x.ConstructionSiteApiTokenId === (accountIdSelected))
  );

  const selectAccountRow = (key: number, accountId: number) => {
    setSelectedServiceRow(undefined);
    setSelectedAccountRow(key);
  };

  const selectServiceRow = (key: number) => {
    setSelectedAccountRow(undefined);
    setSelectedServiceRow(key);
  };

  setTimeout(() => {
    if (keySelected !== undefined) {
      setSelectedAccountRow(keySelected);
      setKeySelected(undefined);
    }
  }, 100);

  if (isSubmited) {
    if (selectedServiceRow !== undefined) {
      const values = {
        Api: Apis[selectedServiceRow],
      };
      onSubmit(values);
    } else if (selectedAccountRow !== undefined && accountsInfo && selectedAccountRow > -1) {
      const values = {
        Api: accountsInfo[selectedAccountRow].Api,
        ExistingConstructionSiteTokenId: accountsInfo[selectedAccountRow].ConstructionSiteApiTokenId,
      };
      onSubmit(values);
    } else {
      onSubmit(undefined, [t('conexaoServico.noServiceSelected')]);
    }
  }

  return (
    <Container>
      <div className="titleStorage" >
        {t('conexaoServico.selectStorageTitle')}
      </div>
      {!!accountsInfo && accountsInfo?.length && accountsInfo.length > 0 && (
        <div>
          <div className="titleServiceList">{t('conexaoServico.connectedAccounts')}</div>
          {accountsInfo?.map((account, key) => (
            <ListContainer
              key={`service-${key}`}
              height={51}
              className={`serviceContainer ${key === selectedAccountRow ? 'active' : ''}`}
              onClick={() => selectAccountRow(key, account.ConstructionSiteApiTokenId)}
            >
              {key === selectedAccountRow ? (
                <Icon
                  icon="confirmacao"
                  customSize={15}
                  className="selectedIcon"
                />
              ) : (
                <span className="unselectedIcon" />
              )}
              <Icon
                icon={getIconApi(account.Api)}
                customSize={20}
                className={`${key === selectedAccountRow ? 'iconServiceActive' : 'iconService'}`}
              />
              <span className="titleService">{ApisEnumLabel[account.Api]}</span>
              <span className="emailService">{account.ApiEmail}</span>
            </ListContainer>
          ))}
        </div>
      )}

      <div>
        <div className="titleServiceList">{t('conexaoServico.connectNew')}</div>
        {Apis.map((api, key) => (
          <ListContainer
            key={`service-${key}`}
            height={51}
            className={`serviceContainer ${key === selectedServiceRow ? 'active' : ''}`}
            onClick={() => selectServiceRow(key)}
          >
            {key === selectedServiceRow ? (
              <Icon
                icon="confirmacao"
                customSize={15}
                className="selectedIcon"
              />
            ) : (
              <span className="unselectedIcon" />
            )}
            <Icon
              icon={getIconApi(api)}
              customSize={20}
              className={`${key === selectedServiceRow ? 'iconServiceActive' : 'iconService'}`}
            />
            <span className="titleService">{ApisEnumLabel[api]}</span>
          </ListContainer>
        ))}
      </div>
    </Container>
  );
};

export default ArmazenamentoTab;
